import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";
import { RecallsDashboardFilters, RecallsDashboardSearchResponse, RecallsLastExportedReponse } from "modules/RecallsDashboard/types";

const component = "RecallsDashboard";

export const RecallsDashboardKeys = {
  search: backendQueryKey<RecallsDashboardSearchResponse>({ component, baseUrl: ENV.readBaseUrl, endpoint: "/recalls/search" }),
  lastImport: backendQueryKey<RecallsLastExportedReponse>({ component, baseUrl: ENV.readBaseUrl, endpoint: "/recalls/last_import" }),
  filters: localQueryKey<RecallsDashboardFilters>({ component, data: "filters" })
};
